import axios from "axios";
import * as cheerio from "cheerio";
export async function fetchDatasheetFromLcscProductPageUrl(productUrl, scraperAPIKey) {
    try {
        let proxyConfig;
        // only run in production
        if (process.env.NODE_ENV === "production") {
            proxyConfig = {
                host: `proxy-server.scraperapi.com`,
                port: 8001,
                auth: { username: "scraperapi", password: scraperAPIKey },
                protocol: "http",
            };
        }
        // Fetch the HTML of the page
        const { data: html } = await axios.get(productUrl, { proxy: proxyConfig });
        // Load the HTML into cheerio for parsing
        const $ = cheerio.load(html);
        // Find the datasheet URL (the selector might vary depending on the page structure)
        const datasheetLink = $('a[href*="datasheet"]').attr("href");
        // Check if the datasheet URL exists
        if (datasheetLink) {
            // The href might be a relative path, so we may need to make it absolute
            return new URL(datasheetLink, productUrl).href;
        }
        else {
            return null;
        }
    }
    catch (error) {
        return null;
    }
}
//# sourceMappingURL=fetchDatasheetFromLcscProductPageUrl.js.map